export default __webpack_public_path__ + "static/media/sherpa.ddda5542.png";